module.exports = {
  id: "Stylable_StylableButton_8",
  preset: { rect: { width: 66, height: 76, x: 258, y: 220 }, tags: null },
  structure: {
    type: "Component",
    metaData: { sig: "4ie-102", pageId: "c1dmp" },
    skin: "wixui.skins.Skinless",
    layout: {
      width: 45,
      height: 45,
      x: 268,
      y: 236,
      scale: 1,
      rotationInDegrees: 0,
      fixedPosition: false,
    },
    componentType: "wixui.StylableButton",
    parent: "comp-knzvqsjj",
    data: {
      type: "StylableButton",
      metaData: {
        isPreset: false,
        schemaVersion: "1.0",
        isHidden: false,
        sig: "q4x-286",
        pageId: "c1dmp",
      },
      label: "Download",
      svgId: "11062b_f735867fea394200a409fe2ffeda6d7e.svg",
    },
    props: {
      type: "StylableButtonProperties",
      metaData: { schemaVersion: "1.0", sig: "hmj-273", pageId: "c1dmp" },
    },
    style: {
      type: "ComponentStyle",
      metaData: {
        isPreset: false,
        schemaVersion: "1.0",
        isHidden: false,
        sig: "4ie-100",
        pageId: "c1dmp",
      },
      style: {
        properties: {
          "$st-css":
            ":import{-st-from: 'wix-ui-santa/index.st.css';-st-named: StylableButton}.root{-st-extends: StylableButton;transition: all 0.2s ease, visibility 0s;background: value(site_1_1);border: 1px solid #0C4426;border-radius: 0px}.root:hover{\n    border-radius: 0px;\n    padding: 0px}.root:hover::icon{width: 25px;height: 25px}.root[disabled]{background: #E2E2E2}.root[disabled]::label{color: #8F8F8F}.root[disabled]::icon{fill: #8F8F8F}.root::container{transition: inherit}.root::label{transition: inherit;font-size: 16px;color: #000000;display: none}.root::icon{transition: inherit;width: 31px;height: 31px;fill: #0C4426}",
        },
        propertiesSource: { "$st-css": "value" },
      },
      componentClassName: "wixui.StylableButton",
      pageId: "",
      compId: "",
      styleType: "custom",
      skin: "wixui.skins.Skinless",
    },
    activeModes: {},
    id: "comp-km97fib5",
    components: [],
  },
};
